module.exports = __webpack_public_path__ + "img/p22.eea390db.png";